module.exports = __webpack_public_path__ + "static/media/rosaparks-mural-outlineonly.29921fac.png";